import React from 'react';

import cx from 'classnames';
import { range } from 'ramda';
import { Link } from 'react-scroll';

import { getOriginTitle } from 'components/Pages/Admin/Page/Landing/utils';
import { useLandingNavigation } from 'hooks/useLandingNavigation';

import { LANDING_PAGES_CONTAINER_ID } from '../Grid';
import s from './index.module.css';
import { INavNotchProps } from './types';

const notches = range(0, 11);

function NavNotch(props: INavNotchProps) {
  const { links = [], className, isPortalItinerary = false, landingTheme } = props;
  const { getBaseOffset, handleLinkClick } = useLandingNavigation({
    isPortalItinerary,
    elemId: 'pageHeadline',
    type: 'navNotch',
    landingTheme,
  });
  const longerArr = notches.length > links.length ? notches : links;

  return (
    <div className={cx(s.wrapper, isPortalItinerary && s.wrapperPortalItinerary, className, 'custom-nav-notch')}>
      {longerArr.map((value, i) => {
        const link = links[i];

        if (link) {
          const realTitle = getOriginTitle(link);
          return (
            <Link
              key={i}
              to={link}
              className={cx(s.link, 'custom-nav-notch-link')}
              activeClass={cx(s.linkActive, 'custom-nav-notch-link-active')}
              containerId={LANDING_PAGES_CONTAINER_ID}
              smooth={true}
              duration={200}
              spy={true}
              offset={getBaseOffset()}
              ignoreCancelEvents={false}
              isDynamic
              onClick={() => handleLinkClick(link, LANDING_PAGES_CONTAINER_ID)}
            >
              <div className={cx(s.text, 'custom-nav-notch-link-text')} data-block>
                {realTitle}
              </div>
              <div className={cx(s.border, 'custom-nav-notch-link-border')} />
            </Link>
          );
        } else {
          return (
            <span key={i} className={cx(s.link, s.disabledLink, 'custom-nav-notch-link')}>
              <div className={cx(s.border, 'custom-nav-notch-link-border')} />
            </span>
          );
        }
      })}
    </div>
  );
}

export default NavNotch;
